var windowW       = $(window).width();
var windowH       = $(window).innerHeight();
var _isSP         = false;
var _isipad  = false;

const bnrClose  = document.getElementById('index-Following_Close');
const indexBnr  = document.getElementById('index-Following');

// 追従バナー
let _isFollowing = false;

// テスト
let _isTest = false;

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//showMovie
import {showMovie} from "../include/module";
showMovie();


$(window).on('load' , function() {

  showNews();
  scrollIndexAnime();
  imgSlide();

  if(_isTest) {

    //アニメーション省略
    $('#index-Loader').remove();

  } else {
    showKV();
  }

});

// ------------------------------------------------------------------------
// imgSlide
// ----- BOTH
// ------------------------------------------------------------------------
const imgSlide = () => {

  var imgNav = new Swiper('.index-Keyvisual_Nav', {
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: 'vertical',
    allowTouchMove: false,//スワイプを可能にするかどうか。デフォルトではtrue。
    slideToClickedSlide: false,
    // preventClicks: false,//反応調整のため追記
    // preventClicksPropagation: false,//反応調整のため追記
    threshold: 40,
    breakpoints: {
      1024: {
        direction: 'horizontal',
      }
    },
  });

  var imgSlider = new Swiper('.index-Keyvisual_Slider', {
    thumbs: {
      swiper: imgNav
    },
    // hashNavigation: {
    //   replaceState: true,
    // },
    slidesPerView: 1,
    initialSlide: 7,
    effect: 'flip',
    speed: 500,
    preventClicks: false,//反応調整のため追記
    preventClicksPropagation: false,//反応調整のため追記
    slideToClickedSlide: true,
    // allowTouchMove: true,//スワイプを可能にするかどうか。デフォルトではtrue。
    //   breakpoints: {
    //   1024: {
    //     allowTouchMove: true,//スワイプを可能にするかどうか。デフォルトではtrue。
    //   }
    // },
  });

};



// ------------------------------------------------------------------------
// scrollIndexAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollIndexAnime = () => {

  const controller = new ScrollMagic.Controller();

  //　スクロールで発火系
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    const scene3 = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .85
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

  //ロゴ調整
  new ScrollMagic.Scene({
    // triggerElement:'#entry',
    triggerHook: 1,
    offset: '120'
  })
  .setClassToggle("#st-Header", "st-Header-small")
  .addTo(controller);

  //見出し
  const ttl = document.querySelectorAll(".sw-Ttl");
  const ttlArray = Array.prototype.slice.call(ttl); //Array
  ttlArray.forEach(target => {
    //シーンを作成
  new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: 1
    })
    .on("enter", function (event) {  // シーンの状態が"DURING"に入る際に発火する
      // console.log("Scene entered.");
      $(target).addClass("is-animated");
      setTimeout(function(){
        $(target).children(".txt").textyleF(
          {
            duration :1000, //エフェクト時間(ミリ秒)
            delay : 60, //文字間のエフェクト間隔(ミリ秒)
            easing : 'cubic-bezier(0.16, 1, 0.3, 1)', //エフェクトのイージングパターン
            callback : function(){
              $(target).addClass("is-completed");
            }
          }
        );
      },300);
    })
    // .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

  new ScrollMagic.Scene({
    triggerElement:'.st-Footer',
    triggerHook: 1,
    offset: '0'
  })
  .setClassToggle("#index-Following", "hidden")
  .addTo(controller);


};

// ------------------------------------------------------------------------
// showNews
// ----- BOTH
// ------------------------------------------------------------------------
const showNews = () => {
  const $body = $('#news-Box_Body');
  const $chara = $('#news-Stage');

  $('.js-comment').on('click', function(){

    const dataNews = $(this).attr('data-news');

    $('#news-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},300,'easeOutQuart',function(){

      // fadeIn
      $chara.stop().fadeIn(400);

      //thumb append
      // $thumb.append('<img src="../assets/images/common/afterglow/thumb_'+dataBnr+'.png">');
      //story append
      // $body.addClass(dataNews);

      $('#news-Box').addClass('show');
      $('[data-modal-content = ' + dataNews + ']').addClass('is-show');

      return false;

  	});

  });


  //close
  $('#news-Box_Close').on('click', function(){

    $('#news-Stage').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){

      $('#news-Stage').css({'display':'none'});
      $('#news-Box').removeClass('show');

      $('[data-modal-content]').removeClass('is-show');

      // // 'body-' で始まるclassをすべて削除
      // $body.removeClass(function(index, className) {
      //   return (className.match(/\bnews-show-\S+/g) || []).join(' ');
      // });
    });
  });

};


// ------------------------------------------------------------------------
// showKV
// ----- BOTH
// ------------------------------------------------------------------------
const showKV = () => {

  setTimeout(function(){$('#index-Loader').addClass("load");},0);
  setTimeout(function(){$('#index-Loader_Txt').addClass("hidden");},0);
  setTimeout(function(){$('#index-Loader_Inner').addClass("hidden");},300);
  setTimeout(function(){$('#index-Loader').addClass("hidden");},1000);
  setTimeout(function(){$('#index-Loader').remove();},2000);

  setTimeout(function(){$('.index-Bg_Item_Orange').addClass("show");},1100);
  setTimeout(function(){$('#st-Header').removeClass("hidden");},1200);
  setTimeout(function(){$('.index-Keyvisual_Slider_Wrapper').removeClass("hidden");},1200);

  setTimeout(function(){
    $('.index-Following').removeClass("hidden");
    _isFollowing = true;
    followingBnr();
  },2000);

};


// ------------------------------------------------------------------------
// followingBnr
// ----- BOTH
// ------------------------------------------------------------------------
const followingBnr = () => {
  bnrClose.addEventListener('click', () => {

    console.log(_isFollowing);

    if(_isFollowing) {
      indexBnr.classList.add('hidden');
      indexBnr.classList.add('disabled');
      _isFollowing = false;
    }

  }, false);

};


// WEBPACK FOOTER //
// ./src/assets/js/index/script.js